module.exports = __webpack_public_path__ + "static/media/republican.fb097145.svg";